import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64a37bd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "wash-phone" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "heading" }, "Телефон Администратора"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "wash-phone__number",
    href: "tel:+79623611601"
  }, "+7 (962) 361-16-01")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AWashServices = _resolveComponent("AWashServices")!
  const _component_AWashPrice = _resolveComponent("AWashPrice")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_AWashServices),
    _createVNode(_component_AWashPrice)
  ], 64))
}